import appConfig from '../../../../../shared/helpers/appConfig';
import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store/index';
import { subscriptionGuard } from '../../../../helper/subscriptionHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const AgentReports = () => import('./AgentReports.vue');
const LabelReports = () => import('./LabelReports.vue');
const InboxReports = () => import('./InboxReports.vue');
const TeamReports = () => import('./TeamReports.vue');
const CsatResponses = () => import('./CsatResponses.vue');
const BotReports = () => import('./BotReports.vue');
const LiveReports = () => import('./LiveReports.vue');
const SLAReports = () => import('./SLAReports.vue');
const AdsReports = () => import('./AdsReports.vue');
const AdsAnalytics = () => import('./AdsAnalytics.vue');
const CustomAnalytics = () => import('./CustomAnalytics.vue');

const routerGuard = async (to, from, next) => {
  // Allow access in development environment or for account ID 212, 295
  const allowedAccounts = [212, 295];
  if (appConfig('VUE_APP_ENV') === 'development' || allowedAccounts.includes(store.getters.getCurrentAccountId)) {
    return next();
  }
  return next({ name: 'dashboard' });
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'OVERVIEW_REPORTS.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      // Router guard to check subscription using cached data
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
      children: [
        {
          path: '',
          redirect: 'overview',
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: LiveReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.HEADER',
        icon: 'chat',
        keepAlive: false,
      },
      children: [
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CSAT_REPORTS.HEADER',
        icon: 'emoji',
        keepAlive: false,
      },
      children: [
        {
          path: 'csat',
          name: 'csat_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: CsatResponses,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'BOT_REPORTS.HEADER',
        icon: 'bot',
        keepAlive: false,
      },
      children: [
        {
          path: 'bot',
          name: 'bot_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: BotReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_REPORTS.HEADER',
        icon: 'people',
        keepAlive: false,
      },
      children: [
        {
          path: 'agent',
          name: 'agent_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: AgentReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_REPORTS.HEADER',
        icon: 'tag',
        keepAlive: false,
      },
      children: [
        {
          path: 'label',
          name: 'label_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: LabelReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'INBOX_REPORTS.HEADER',
        icon: 'mail-inbox-all',
        keepAlive: false,
      },
      children: [
        {
          path: 'inboxes',
          name: 'inbox_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: InboxReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAM_REPORTS.HEADER',
        icon: 'people-team',
      },
      children: [
        {
          path: 'teams',
          name: 'team_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: TeamReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SLA_REPORTS.HEADER',
        icon: 'document-list-clock',
        keepAlive: false,
      },
      children: [
        {
          path: 'sla',
          name: 'sla_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: SLAReports,
        },
      ],
    },
    // {
    //   path: frontendURL('accounts/:accountId/reports'),
    //   component: SettingsContent,
    //   props: {
    //     headerTitle: 'ADS_REPORTS.HEADER',
    //     icon: 'document-list-clock',
    //     keepAlive: false,
    //   },
    //   children: [
    //     {
    //       path: 'ads',
    //       name: 'ads_reports',
    //       meta: {
    //         permissions: ['administrator', 'agent', 'service_agent'],
    //       },
    //       component: AdsReports,
    //     },
    //   ],
    // },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'ADS_ANALYTICS.HEADER',
        icon: 'document-list-clock',
        keepAlive: false,
      },
      children: [
        {
          path: 'ads-analytics',
          name: 'ads_analytics_reports',
          meta: {
            permissions: ['administrator', 'agent', 'service_agent'],
          },
          component: AdsAnalytics,
        },
      ],
      beforeEnter: routerGuard,
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CUSTOM_ANALYTICS.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
      children: [
        {
          path: 'custom-analytics',
          name: 'custom_analytics_reports',
          meta: {
            // The backend answers 403 `admin_required` to anyone else.
            permissions: ['administrator'],
          },
          component: CustomAnalytics,
        },
      ],
    },
  ],
};
